import { ISmartProps } from './types';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps) => {
	const { overrides, ...rest } = props;
	return {
		Root: {
			style: ({ $theme, $size }: any) => {
				return {
					backgroundColor: 'var(--epods--color-bg-avatar)',
					width: $size ? $size : $theme.avatar.size,
					minWidth: $size ? $size : $theme.avatar.size,
					maxWidth: $size ? $size : $theme.avatar.size,
					height: $size ? $size : $theme.avatar.size,
					minHeight: $size ? $size : $theme.avatar.size,
					maxHeight: $size ? $size : $theme.avatar.size,
				};
			},
			props: {
				'data-epo': `epo-avatar-${meta.version}`,
				part: `epo-avatar-${meta.version}`,
				...rest
			},
		},

		Avatar: {
			style: ({ $theme, $size, $didImageFailToLoad }: any) => {
				const bg = $didImageFailToLoad ? { backgroundColor: 'var(--epods--color-bg-avatar)' } : {};
				return {
					...bg,
					width: $size ? $size : $theme.avatar.size,
					minWidth: $size ? $size : $theme.avatar.size,
					maxWidth: $size ? $size : $theme.avatar.size,
					height: $size ? $size : $theme.avatar.size,
					minHeight: $size ? $size : $theme.avatar.size,
					maxHeight: $size ? $size : $theme.avatar.size,
				};
			},
		},

		Initials: {
			props: {
				'aria-hidden': true,
			},
			style: ({ $theme }: any) => {
				return {
					fontFamily: $theme.avatar.fontFamily,
					color: 'var(--epods--color-text-inverted)',
				};
			},
		},
	};
};
